/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import navbarSearchAndPinList from '@/layouts/components/navbar/navbarSearchAndPinList'
import themeConfig from '@/../themeConfig.js'
import colors from '@/../themeConfig.js'

// /////////////////////////////////////////////
// Helper
// /////////////////////////////////////////////

// *From Auth - Data will be received from auth provider
const userDefaults = {
  uid         : 0,          // From Auth
  displayName : 'Super Admin', // From Auth
  about       : 'Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.',
  photoURL    : 'null',
  status      : 'online',
  userRole    : 'admin'
}


// Check if device is touch device
// This is used to remove perfect scrollbar from touch devices
// Using Dynamic components
const is_touch_device = () => {
  const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ')
  const mq = function (query) {
    return window.matchMedia(query).matches
  }

  if (('ontouchstart' in window) || window.DocumentTouch) {
    return true
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('')
  return mq(query)
}


// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////
const state = {
  AppActiveUser           : userDefaults,
  bodyOverlay             : false,
  isVerticalNavMenuActive : true,
  is_touch_device         : is_touch_device(),
  mainLayoutType          : themeConfig.mainLayoutType || 'hidden',
  navbarSearchAndPinList,
  reduceButton            : themeConfig.sidebarCollapsed,
  verticalNavMenuWidth    : 'default',
  verticalNavMenuItemsMin : false,
  scrollY                 : 0,
  starredPages            : navbarSearchAndPinList['pages'].data.filter((page) => page.is_bookmarked),
  theme                   : themeConfig.theme || 'light',
  themePrimaryColor       : colors.primary,
  themeTitle              : themeConfig.AppTitle,
  topBarTitle             : themeConfig.topBarTitle,
  themeLogo              : themeConfig.themeLogo,
  navbarcolor            : colors.primary,
  showLoginImg           : false,

  // Can be used to get current window with
  // Note: Above breakpoint state is for internal use of sidebar & navbar component
  windowWidth: null,
  student:null,
  newsletter_json:null,
  resize_width:null,
  resize_imgs:[],
  complete_resize_img:null,
  start_resize_img:null,
  builder_menu:null,
  deletedUser:null,
  emailRegisteredUser:null,
  currentLocation:null,
  currentLocationDropdown:null,
  activitiesAppProgramDropdown:[],
  activitiesAppProgramStudentDropdown:[],
  currentAppActivityRoom:null,
  topbarMessageCounter:0,
  schoolTitle:null,
  schoolCameraLoginFeature:true,
  showTopNavbar:true,
  currentStudentAccountDetails:null,
  currentLocationPendingUser:null,
  currentLocationStaticCard:null,
  currentAgencyAccountDetails:null,
  currentAgencyStudents:[],
  setupFormSteps:[
    {
      text: 'Add your first location',
      name: 'Add Location',
      status:true,
      url:'locations',
      key: 'isLocation'
    },
    {
      text: 'Add your first camera',
      name: 'Add Camera',
      status:true,
      url:'cameras',
      key: 'isCamera'
    },
    {
      text: 'Add your first streaming server',
      name: 'Add Streaming Server',
      status:true,
      url:'streaming-servers',
      key: 'isStream'
    },
    // {
    //   text: 'Set camera setting',
    //   name: 'Set Camera Setting',
    //   status:true,
    //   url: 'manage-location',
    //   key: 'isSetting'
    // },
    {
      text: 'Add your school profile',
      name: 'Add School Profile',
      status:true,
      url:'school_profile',
      key: 'isSchool'
    },
    {
      text: 'Add your first room',
      name: 'Add Room',
      status:true,
      url:'rooms',
      key: 'isRoom'
    },
    {
      text: 'Add first center admin or manager',
      name: 'Add Manager',
      status:true,
      url:'team',
      key: 'isManager'
    },
    {
      text: 'Add your first contact',
      name: 'Add Contact',
      status:true,
      url:'users',
      key: 'isContact'
    },
    {
      text: 'Add your first student',
      name: 'Add Student',
      status:true,
      url:'students',
      key: 'isStudent'
    }

  ],
  bucketInfo:null,
  onlineUsers:[],
  fileMessages: {
    file: {
      key:null,
      location:null,
      original:null
    },
    visible: false
  },
  dashBoardLayout:null,
  dashBoardLayouts:null,
  teacherMessageCount:0,
  cameraModule:true,
  shareCustomNewsletter:false,
  avatarUpload:false
}

export default state
